<form [formGroup]="addWorkspaceForm" (ngSubmit)="onSubmit()">
    <div class="dialog-header"> 
        <h2 class="dialog-title">New Workspace Creation</h2>   
        <button class="cancel-button" mat-button type="button" [disabled]="isSubmitting()" (click)="onCancel()">Cancel</button>
    </div>
    <div class="dialog-body">
        <mat-dialog-content class="dialog-form">
            <mat-form-field>
                <mat-label>Workspace Alias</mat-label>
                <input class="input" matInput maxlength="128" formControlName="workspaceAlias">
            </mat-form-field>
            @if (addWorkspaceForm.get('workspaceAlias')?.errors?.['pattern']) {
                <mat-error>Workspace alias must be empty or between 3 and 128 characters, cannot start or end with spaces, and cannot consist only of spaces.</mat-error>
            }
            <div class="toggle-container">
                <mat-slide-toggle formControlName="privateAccessToWorkspace"></mat-slide-toggle>
                <mat-label class="toggle-button-label"> Private Access to Workspace </mat-label>
            </div>
            <div class="info-message">
                <mat-icon>info</mat-icon>
                <p class="info-text">Workspace creation/configuration may take up to 20 minutes. The process will continue even if you leave this page or close the dialog, but progress and completion will not be visible.</p>
            </div>
            @if (submissionErrorMessage()) {
                <div class="error-message">{{submissionErrorMessage()}}</div>
            }
        </mat-dialog-content>     
    </div>
    <mat-dialog-actions class="dialog-footer">
        <button class="submit-button" mat-flat-button 
            color="primary"
            type="submit" 
            [disabled]="!addWorkspaceForm.valid || isSubmitting()"> 
            @if (!isSubmitting()) {
                Create Workspace
            } @else {
                <div class="submission-message">
                    <div class="submit-loading-spinner">
                        <app-loading-spinner [strokeWidth]="5"></app-loading-spinner>
                    </div>
                    @if (this.workspaceCreationStage() === workspaceCreationStateEnum.Creating) {
                        <p>Creating Workspace...</p>
                    } @else if (this.workspaceCreationStage() === workspaceCreationStateEnum.Configuring) {
                        <p>Configuring Workspace...</p>
                    }
                </div>
            }   
        </button>
    </mat-dialog-actions>
</form>